(() => {
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  if (!('IntersectionObserver' in window) || motion.matches) return;
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      entry.target.classList.add('rr-enter');
      observer.unobserve(entry.target);
    }
  }, { threshold: 0.08 });
  const seen = new WeakSet();
  const setup = (root = document) => {
    root.querySelectorAll('#MainContent h2, .rr-product, .rr-bike').forEach(element => {
      if (seen.has(element)) return;
      seen.add(element);
      if (element.getBoundingClientRect().top > innerHeight) observer.observe(element);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(), { once: true });
  else setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('h2,.rr-product,.rr-bike').forEach(element => observer.unobserve(element));
  });
  motion.addEventListener('change', () => { if (motion.matches) observer.disconnect(); });
})();
